import { loadStripe } from '@stripe/stripe-js';

export default class VideoRequestBloc {
  constructor({ paymentRepository, errorRepository, freshchatService }) {
    this.paymentRepository = paymentRepository;
    this.errorRepository = errorRepository;
    this.freshchatService = freshchatService;
  }

  async initStripe() {
    if (!this.stripe) {
      this.stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY, {
        apiVersion: '2020-08-27',
      });
    }
  }

  async redirectToPayment(studyId, currentRoute = null) {
    await this.initStripe();
    const { sessionId } = await this.paymentRepository.createCaseCheckoutSession(studyId, currentRoute);
    const result = await this.stripe.redirectToCheckout({ sessionId });
    if (result.error) {
      this.errorRepository.error$.next(result.error);
    }
  }

  openFreshchatDialog() {
    this.freshchatService.openDialog();
  }
}
